import { render, staticRenderFns } from "./EquipmentWashingMachine.vue?vue&type=template&id=c481279c&scoped=true"
import script from "./EquipmentWashingMachine.vue?vue&type=script&lang=ts"
export * from "./EquipmentWashingMachine.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentWashingMachine.vue?vue&type=style&index=0&id=c481279c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c481279c",
  null
  
)

export default component.exports